function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 595.28 534.89"
  }, props), /*#__PURE__*/React.createElement("rect", {
    width: 427.32,
    height: 427.32,
    x: 83.98,
    y: 53.78,
    rx: 213.66,
    ry: 213.66,
    style: {
      fill: "#00333e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.75 369.21c-11.97-3.85-20.02-11.55-24.34-23.18-10.53-28.42-13.65-147.29 6.63-170.71 6.94-8 15.86-12.68 26.49-13.8 54.66-5.77 223.63-4.95 243.1 1.94 11.41 4.02 19.5 11.35 23.91 22.55 11.53 29.37 11.93 136.25-1.53 164.55-3.65 7.67-9.59 13.09-17.14 16.97-20.38 10.49-230.29 10.36-257.12 1.69Zm86.84-55.71c32.87-16.72 65.46-33.3 98.46-50.07-33.05-16.91-65.63-33.58-98.46-50.38v100.46Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }));
};
export default SvgYoutube;